import React, { useEffect, useState } from 'react';
import { Polygon } from 'react-leaflet';

const SignalPropagation = ({ nodeId, latitude, longitude, show }) => {
  const [propagationData, setPropagationData] = useState(null);

  useEffect(() => {
    if (!show || !nodeId) {
      setPropagationData(null);
      return;
    }

    // Fetch propagation data from backend
    fetch(`/api/MapNodes/${nodeId}/propagation`)
      .then(res => res.json())
      .then(data => {
        if (data && data.length > 0) {
          setPropagationData(data);
        }
      })
      .catch(err => console.error('Error fetching propagation data:', err));
  }, [nodeId, show]);

  if (!show || !propagationData || propagationData.length === 0) {
    return null;
  }

  // Group points by intensity for concentric polygons
  const ringGroups = {};
  propagationData.forEach(point => {
    const intensityLevel = Math.round(point.intensity * 10) / 10;
    if (!ringGroups[intensityLevel]) {
      ringGroups[intensityLevel] = [];
    }
    ringGroups[intensityLevel].push([point.latitude, point.longitude]);
  });

  // Color mapping based on signal intensity
  const getColorForIntensity = (intensity) => {
    if (intensity > 0.7) return { color: '#48c774', fillOpacity: 0.4, label: 'Strong Signal' }; // Green
    if (intensity > 0.5) return { color: '#00d1b2', fillOpacity: 0.35, label: 'Good Signal' }; // Turquoise
    if (intensity > 0.3) return { color: '#ffdd57', fillOpacity: 0.3, label: 'Weak Signal' }; // Yellow
    return { color: '#ff3860', fillOpacity: 0.25, label: 'Very Weak Signal' }; // Red
  };

  // Sort ring groups by intensity (highest to lowest) for proper layering
  const sortedRings = Object.entries(ringGroups).sort(([a], [b]) => parseFloat(b) - parseFloat(a));

  return (
    <>
      {/* Render polygons from weakest to strongest for proper layering */}
      {sortedRings.reverse().map(([intensity, points]) => {
        const { color, fillOpacity } = getColorForIntensity(parseFloat(intensity));
        
        // Sort points by angle to create a proper polygon shape
        const centerLat = latitude;
        const centerLon = longitude;
        const sortedPoints = [...points].sort((a, b) => {
          const angleA = Math.atan2(a[0] - centerLat, a[1] - centerLon);
          const angleB = Math.atan2(b[0] - centerLat, b[1] - centerLon);
          return angleA - angleB;
        });
        
        return (
          <Polygon
            key={`ring-${intensity}`}
            positions={sortedPoints}
            pathOptions={{
              color: color,
              fillColor: color,
              fillOpacity: fillOpacity,
              weight: 1,
              opacity: 0.5
            }}
          />
        );
      })}
    </>
  );
};

export default SignalPropagation;

